module.exports = __webpack_public_path__ + "fonts/CooperHewitt-Medium.f963323.otf";